import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'There are risks involved with staking your assets. To learn more follow me {here}!',
  here: 'here',
});
